import { useMemo } from 'react';
import { UserRole } from '@engelvoelkersamericas/common-ui';

import { ProfileAppMode } from '@models';
import { useProfileStore } from '@stores';
import { PROTECT_PAGES_BY_ROLES } from '@configs/constants';

/**
 * Hook to derive base roles based on the current profile mode
 * @returns Object containing base roles and profile mode information
 */
export const useBaseRoles = () => {
  const { profileAppMode } = useProfileStore((state) => state);

  return useMemo(() => {
    // Determine if we're in other user profile mode
    const isOtherUserProfile = profileAppMode === ProfileAppMode.OTHER_PROFILE;

    // Base roles depend on the profile mode
    const baseRoles: UserRole[] = isOtherUserProfile ? PROTECT_PAGES_BY_ROLES.OtherUserProfilePage : [UserRole.ADVISOR];

    return {
      baseRoles,
      isOtherUserProfile,
    };
  }, [profileAppMode]);
};
